import React from "react";
import { getNextElement, getPreviousElement } from "./utils";

export const FocusBoundary = ({ children }: React.PropsWithChildren<unknown>) => {
  const focusFront = (e: React.FocusEvent) => {
    e.preventDefault();
    e.stopPropagation();

    const nextElement = getNextElement();
    if (nextElement) {
      nextElement.focus();
    }
  }

  const focusBack = (e: React.FocusEvent) => {
    e.preventDefault();
    e.stopPropagation();

    const previousElement = getPreviousElement();
    if (previousElement) {
      previousElement.focus();
    }
  }

  return <>
    <div onFocus={focusFront} tabIndex={0} />
    {children}
    <div onFocus={focusBack} tabIndex={0} />
  </>
}